import $$ from '@/store/plugins/storage'

const namespace = 'followCustom'
$$.setNamespace(namespace)

const state = {
  id: 1
}

const mutations = {
  _id (state, value) {
    state.id = value
  }
}

export default { namespaced: true, state, mutations }



// WEBPACK FOOTER //
// ./src/store/modules/followCustom.js